webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Calculator',
  data: function data() {
    return {
      computationMode: 'none',
      showComputationMode: true,
      inputNumber: true,

      isFloat: false,
      floatValueDivisor: 1,
      floatValue: 0,
      intValue: 0,
      numericDisplayString: '0',
      numericValue: 0,
      settingsButtonClicked: 0,
      previousNumber: 0,
      clearValue: 'AC',

      equalsTapped: 0,

      separatorOperator: 'multiply',
      forceNumberTap: 4,

      fontSize: 10.5833
    };
  },

  methods: {
    touchStartHandler: function touchStartHandler(e) {
      e.target.classList.add('active');
    },
    touchEndHandler: function touchEndHandler(e) {
      e.target.classList.remove('active');
    },
    updateNumericValue: function updateNumericValue() {
      this.numericValue = this.intValue + this.floatValue / this.floatValueDivisor;
    },
    updateNumericDisplay: function updateNumericDisplay() {
      this.numericDisplayString = Number(this.intValue).toLocaleString();

      if (this.isFloat) {
        this.numericDisplayString += '.'; // eslint-disable-line

        if (this.floatValue !== 0) {
          this.numericDisplayString += this.floatValue; // eslint-disable-line
        }
      }

      // this.numericDisplayString = this.numericDisplayString;

      // Update font size
      if (this.numericDisplayString.length > 11) {
        this.fontSize = 116.4163 / this.numericDisplayString.length;
      } else {
        this.fontSize = 10.5833;
      }
    },
    resetSettingsTrigger: function resetSettingsTrigger() {
      this.settingsButtonClicked = 0;
    },
    percentage: function percentage() {
      this.intValue /= 100;
    },
    settingsTrigger: function settingsTrigger() {
      var minimumSettingsTap = localStorage.getItem('minimumSettingsTap') || 4;
      this.settingsButtonClicked += 1;

      if (!localStorage.getItem('performPercentage')) {
        // this.percentage();
      }

      if (this.settingsButtonClicked >= minimumSettingsTap) {
        this.$router.push('Settings');
      }
    },
    equals: function equals() {
      var newValue = 0; // eslint-disable-line
      var multiplier = 1;
      var decimal = 0;
      var decimalLength = 0;

      switch (this.computationMode) {
        case 'addition':
          newValue = this.previousNumber + this.numericValue;
          break;
        case 'subtract':
          newValue = this.previousNumber - this.numericValue;
          break;
        case 'multiply':
          window.console.log(this.previousNumber * this.numericValue, this.previousNumber, this.numericValue);
          newValue = this.previousNumber * this.numericValue;
          break;
        case 'divide':
          newValue = this.previousNumber / this.numericValue;
          break;
        default:
          newValue = 0;
      }

      if (newValue < 0) {
        multiplier = -1;
      }

      this.clear();

      // Set the int value of the number system
      this.intValue = Math.floor(Math.abs(newValue));

      // Set the float value of the number system
      decimal = String(Math.abs(newValue) - this.intValue);
      decimal = decimal.split('.')[1];

      if (decimal) {
        this.isFloat = true;
        decimalLength = decimal.length;
        decimal = window.Number.parseInt(decimal);
      } else {
        decimal = 0;
        decimalLength = 1;
      }

      // Set float value divisor
      this.floatValue = decimal;
      this.floatValueDivisor = Math.pow(10, decimalLength); // eslint-disable-line
      this.intValue *= multiplier;

      if (this.equalsTapped >= this.forceNumberTap) {
        this.isFloat = false;
        this.intValue = localStorage.getItem('forceNumber');
      }

      this.updateValues();
    },
    clear: function clear() {
      this.computationMode = 'none';
      this.showComputationMode = true;
      this.floatValueDivisor = 1;
      this.numericDisplayString = '0';
      this.numericValue = 0;
      this.settingsButtonClicked = 0;
      this.previousNumber = 0;

      this.clearNumberSystem();
    },
    pushNumericDisplay: function pushNumericDisplay(num) {
      if (!this.isFloat) {
        var newNum = this.intValue;

        newNum *= 10;
        newNum += num;

        this.intValue = newNum;
      } else {
        var _newNum = this.floatValue;

        _newNum *= 10;
        _newNum += num;

        this.floatValue = _newNum;
        this.floatValueDivisor *= 10;
      }
    },
    clearNumberSystem: function clearNumberSystem() {
      this.floatValue = 0;
      this.intValue = 0;
      this.isFloat = false;
      this.floatValueDivisor = 1;
    },
    clearButtonHandler: function clearButtonHandler() {
      this.resetSettingsTrigger();
      if (this.floatValue !== 0 || this.intValue !== 0) {
        // C
        this.clearNumberSystem();
        this.floatValueDivisor = 1;
      } else {
        // AC
        this.clear();
        this.equalsTapped = 0;
        this.$root.$data.values = [];
      }
    },
    numericButtons: function numericButtons(e) {
      if (this.numericDisplayString.length >= 11 && this.computationMode === 'none') {
        return;
      }

      if (this.computationMode !== 'none' && !this.inputNumber) {
        this.previousNumber = this.numericValue;
        this.showComputationMode = false;

        this.clearNumberSystem();

        this.inputNumber = true;
      }

      var num = window.Number.parseInt(e.toElement.innerText);
      this.pushNumericDisplay(num);
      this.resetSettingsTrigger();
    },
    decimalHandler: function decimalHandler() {
      var newNum = this.intValue;
      newNum *= 1.0;

      this.isFloat = true;
      this.updateNumericDisplay(newNum);
    },
    storeValue: function storeValue() {
      this.$root.$data.values.push(this.intValue);
      this.equalsTapped += 1;
    },
    operatorHandler: function operatorHandler(e) {
      var computationMode = 'none';

      switch (e.toElement.innerText) {
        case '+':
          computationMode = 'addition';
          break;
        case '-':
          computationMode = 'subtract';
          break;
        case 'X':
          computationMode = 'multiply';
          break;
        default:
          computationMode = 'divide';
          break;
      }

      if (this.separatorOperator === computationMode) {
        this.storeValue();
      }

      if (this.computationMode !== 'none') {
        this.equals();
        this.previousNumber = this.numericValue;
        this.showComputationMode = true;
      }

      this.computationMode = computationMode;

      this.inputNumber = false;
    },
    equalsHandler: function equalsHandler() {
      if (this.computationMode !== 'none') {
        this.storeValue();
        this.equals();
        this.computationMode = 'none';
      }
    },
    flipSignHandler: function flipSignHandler() {
      this.intValue *= -1;
    },
    updateClearValue: function updateClearValue() {
      if (this.floatValue !== 0 || this.intValue !== 0) {
        // C
        this.clearValue = 'C';
      } else {
        // CA
        this.clearValue = 'AC';
      }
    },
    deleteHandler: function deleteHandler() {
      if (this.isFloat) {
        this.floatValue = Math.floor(this.floatValue / 10);
        this.floatValueDivisor /= 10;
      } else {
        this.intValue = Math.floor(this.intValue / 10);
      }

      if (this.floatValue === 0) {
        this.isFloat = false;
        this.floatValue = 0;
      }
    },
    updateValues: function updateValues() {
      this.updateNumericValue();
      this.updateNumericDisplay();
      this.updateClearValue();
    }
  },
  watch: {
    floatValue: function floatValue() {
      this.updateValues();
    },
    intValue: function intValue() {
      this.updateValues();
    }
  },
  mounted: function mounted() {
    // Initial setup
    if (!localStorage.getItem('minimumSettingsTap')) {
      localStorage.setItem('forceNumber', String(new Date().getTime()));
      localStorage.setItem('minimumSettingsTap', String(4));
      localStorage.setItem('separatorOperator', 'multiply');
      localStorage.setItem('forceNumberTap', String(4));
    }

    // Reload data from previous session
    this.computationMode = localStorage.getItem('computationMode') || 'none';
    this.floatValueDivisor = window.Number.parseInt(localStorage.getItem('floatValueDivisor')) || 10;
    this.floatValue = window.Number.parseInt(localStorage.getItem('floatValue')) || 0;
    this.intValue = window.Number.parseInt(localStorage.getItem('intValue')) || 0;
    this.numericDisplayString = localStorage.getItem('numericDisplayString') || '0';
    this.previousNumber = window.Number.parseFloat(localStorage.getItem('previousNumber')) || 0;
    this.equalsTapped = window.Number.parseFloat(localStorage.getItem('equalsTapped')) || 0;

    this.showComputationMode = localStorage.getItem('showComputationMode') || true;
    this.inputNumber = localStorage.getItem('inputNumber') || true;
    this.isFloat = localStorage.getItem('isFloat') || false;

    if (typeof this.showComputationMode === 'string') {
      this.showComputationMode = this.showComputationMode === 'true';
    }
    if (typeof this.inputNumber === 'string') {
      this.inputNumber = this.inputNumber === 'true';
    }
    if (typeof this.isFloat === 'string') {
      this.isFloat = this.isFloat === 'true';
    }

    this.separatorOperator = localStorage.getItem('separatorOperator');
    this.forceNumberTap = window.Number.parseInt(localStorage.getItem('forceNumberTap'));

    this.updateNumericValue();
    this.updateNumericDisplay();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    localStorage.setItem('computationMode', this.computationMode);
    localStorage.setItem('inputNumber', this.inputNumber);
    localStorage.setItem('showComputationMode', this.showComputationMode);
    localStorage.setItem('isFloat', this.isFloat);
    localStorage.setItem('floatValueDivisor', this.floatValueDivisor);
    localStorage.setItem('floatValue', this.floatValue);
    localStorage.setItem('intValue', this.intValue);
    localStorage.setItem('numericDisplayString', this.numericDisplayString);
    localStorage.setItem('numericValue', this.numericValue);
    localStorage.setItem('settingsButtonClicked', this.settingsButtonClicked);
    localStorage.setItem('previousNumber', this.previousNumber);
    localStorage.setItem('equalsTapped', this.equalsTapped);
    next();
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',
  data: function data() {
    return {
      forceNumber: '',
      settingsTap: 4,
      forceNumberTap: 4,
      separatorOperator: 'multiply',
      separatorOperator_options: [{ text: 'Addition (+)', value: 'addition' }, { text: 'Subtraction (-)', value: 'subtract' }, { text: 'Multiply (x)', value: 'multiply' }, { text: 'Divide (÷)', value: 'divide' }]
    };
  },
  mounted: function mounted() {
    var forceNumber = localStorage.getItem('forceNumber');
    var settingsTap = localStorage.getItem('minimumSettingsTap');
    var separatorOperator = localStorage.getItem('separatorOperator');
    var forceNumberTap = localStorage.getItem('forceNumberTap');

    this.forceNumber = forceNumber;
    this.settingsTap = window.Number.parseInt(settingsTap);
    this.separatorOperator = separatorOperator;
    this.forceNumberTap = window.Number.parseInt(forceNumberTap);
  },

  watch: {
    forceNumber: function forceNumber() {
      localStorage.setItem('forceNumber', this.forceNumber);
    },
    settingsTap: function settingsTap() {
      localStorage.setItem('minimumSettingsTap', this.settingsTap);
    },
    forceNumberTap: function forceNumberTap() {
      localStorage.setItem('forceNumberTap', this.forceNumberTap);
    },
    separatorOperator: function separatorOperator() {
      localStorage.setItem('separatorOperator', this.separatorOperator);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(14);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  data: function data() {
    return {
      values: []
    };
  }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ff8d799_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(13);
function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ff8d799_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Calculator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings__ = __webpack_require__(19);


// import Hello from '@/components/Hello';



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Calculator',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Calculator__["a" /* default */]
  }, {
    path: '/Settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Settings__["a" /* default */]
  }, {
    path: '/*',
    name: 'InvalidPath',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Calculator__["a" /* default */]
  }]
}));

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23735b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__(18);
function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23735b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Calculator"},[_c('div',{staticClass:"numericDisplay"},[_c('div',{staticClass:"container",style:({ fontSize: _vm.fontSize + 'mm' })},[_vm._v("\n      "+_vm._s(_vm.numericDisplayString)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"keypad"},[_c('button',{staticClass:"row1",on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.clearButtonHandler}},[_vm._v(_vm._s(_vm.clearValue))]),_vm._v(" "),_c('button',{staticClass:"row1",on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.flipSignHandler}},[_vm._v("+/-")]),_vm._v(" "),_c('button',{staticClass:"row1",on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.settingsTrigger}},[_vm._v("%")]),_vm._v(" "),_c('button',{staticClass:"row1",on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.deleteHandler}},[_vm._v("DEL")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("7")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("8")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"last",class:{ focus: (_vm.computationMode == 'divide' && _vm.showComputationMode) },staticStyle:{"font-size":"20pt"},on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.operatorHandler}},[_vm._v("÷")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("4")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("5")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"last",class:{ focus: (_vm.computationMode == 'multiply' && _vm.showComputationMode) },on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.operatorHandler}},[_vm._v("X")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("1")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("2")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"last",class:{ focus: (_vm.computationMode == 'subtract' && _vm.showComputationMode) },staticStyle:{"font-size":"20pt"},on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.operatorHandler}},[_vm._v("-")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.numericButtons}},[_vm._v("0")]),_vm._v(" "),_c('button',{on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.decimalHandler}},[_vm._v(".")]),_vm._v(" "),_c('button',{staticClass:"equals",on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.equalsHandler}},[_vm._v("=")]),_vm._v(" "),_c('button',{staticClass:"last",class:{ focus: (_vm.computationMode == 'addition' && _vm.showComputationMode) },staticStyle:{"font-size":"20pt"},on:{"touchstart":_vm.touchStartHandler,"touchend":_vm.touchEndHandler,"click":_vm.operatorHandler}},[_vm._v("+")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79008a6d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(21);
function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79008a6d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Settings"},[_c('div',{staticClass:"settingsContainer"},[_c('div',{staticClass:"dataView"},[(_vm.$root.$data.values.length > 0)?_c('ul',_vm._l((_vm.$root.$data.values),function(value){return _c('li',[_vm._v("\n          "+_vm._s(value)+"\n        ")])}),0):_vm._e(),_vm._v(" "),(_vm.$root.$data.values.length == 0)?_c('p',[_vm._v("Numbers will be displayed here")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"formGroup"},[_c('label',{attrs:{"for":"forceNumber"}},[_vm._v("Force Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceNumber),expression:"forceNumber"}],attrs:{"type":"text","id":"forceNumber","name":"forceNumber"},domProps:{"value":(_vm.forceNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.forceNumber=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"formGroup"},[_c('label',{attrs:{"for":"settingsTap"}},[_vm._v("Taps to Open Settings")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingsTap),expression:"settingsTap"}],attrs:{"type":"number","id":"settingsTap","name":"settingsTap"},domProps:{"value":(_vm.settingsTap)},on:{"input":function($event){if($event.target.composing){ return; }_vm.settingsTap=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"formGroup"},[_c('label',{attrs:{"for":"separatorOperator"}},[_vm._v("Separator Sign")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.separatorOperator),expression:"separatorOperator"}],staticStyle:{"border":"solid 1px #000000"},attrs:{"name":"separatorOperator","id":"separatorOperator"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.separatorOperator=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.separatorOperator_options),function(option){return _c('option',{domProps:{"value":option.value}},[_vm._v("\n          "+_vm._s(option.text)+"\n        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"formGroup"},[_c('label',{attrs:{"for":"forceNumberTap"}},[_vm._v("Taps to Force Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.forceNumberTap),expression:"forceNumberTap"}],attrs:{"type":"number","id":"forceNumberTap","name":"forceNumberTap"},domProps:{"value":(_vm.forceNumberTap)},on:{"input":function($event){if($event.target.composing){ return; }_vm.forceNumberTap=$event.target.value}}})])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('button',{staticClass:"close"},[_vm._v("Close")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.4acb1631ce310a3b0f87.js